export default "__VITE_ASSET__4499033e__"